/*
 * A única porta de saída para o dataLayer.
 *
 * Nenhum componente escreve no dataLayer direto: todos passam pelas funções
 * de ./index, que chegam aqui. Três garantias moram neste arquivo:
 *
 * 1. O site nunca depende do GTM. O dataLayer é uma lista comum do navegador;
 *    se o GTM for bloqueado ou não carregar, os eventos só ficam guardados nela.
 *    E toda escrita está dentro de try/catch — rastreamento não derruba clique.
 *
 * 2. A equipe fica fora dos números. Nada é enviado antes de a sessão ser
 *    conhecida: os eventos esperam numa fila curta e, quando a conta carrega,
 *    ou saem (cliente) ou são descartados (administrador).
 *
 * 3. Em desenvolvimento cada evento aparece no console, para conferir sem GTM.
 */

export type Payload = { event: string } & Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/** Limite da fila de espera: a conta carrega em milissegundos, isto é folga. */
const LIMITE_FILA = 60;

let sessaoConhecida = false;
let administrador = false;
const fila: Payload[] = [];

function escrever(p: Payload): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.debug(`[tracking] ${p.event}`, p);
  }
  const dl = (window.dataLayer = window.dataLayer ?? []);
  // Recomendação do GTM para comércio eletrônico: limpar o objeto anterior,
  // senão itens de um evento vazam para o próximo que não traga os seus.
  if ('ecommerce' in p) dl.push({ ecommerce: null });
  dl.push(p);
}

/** Informa ao rastreamento quem está navegando. Chamado pela ponte do App. */
export function definirSessao(opts: { conhecida: boolean; administrador: boolean }): void {
  try {
    sessaoConhecida = opts.conhecida;
    administrador = opts.administrador;
    if (!sessaoConhecida) return;
    const pendentes = fila.splice(0, fila.length);
    if (administrador) return;
    for (const p of pendentes) escrever(p);
  } catch {
    // rastreamento nunca interrompe o site
  }
}

export function enviar(p: Payload): void {
  try {
    if (typeof window === 'undefined') return;
    if (!sessaoConhecida) {
      if (fila.length < LIMITE_FILA) fila.push(p);
      return;
    }
    if (administrador) return;
    escrever(p);
  } catch {
    // rastreamento nunca interrompe o site
  }
}
